import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Header.css";
import { useChat } from "../context/ChatContext";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeCategory, setActiveCategory] = useState("SHOP");
  const [showNotificationTooltip, setShowNotificationTooltip] = useState(false);
  const { focusChatInput, blurChatInput, isFocused } = useChat();

  const handleSearchClick = () => {
    if (isFocused) {
      blurChatInput();
    } else {
      focusChatInput();
    }
  };

  const handleNotificationClick = () => {
    setShowNotificationTooltip(true);
    // Hide tooltip after 5 seconds
    setTimeout(() => {
      setShowNotificationTooltip(false);
    }, 5000);
  };

  const handleCategoryClick = (category) => {
    setActiveCategory(category);
    // Navigate to category page or filter content
  };

  return (
    <>
      <header className="header">
        <div className="header-top">
          <button className="header-icon-btn" onClick={handleSearchClick}>
            {isFocused ? (
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            ) : (
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.35-4.35"></path>
              </svg>
            )}
          </button>
          <h1 className="header-title">DUBAI MALL</h1>
          <div className="notification-wrapper">
            <button className="header-icon-btn" onClick={handleNotificationClick}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>
            </button>
          </div>
        </div>
        {showNotificationTooltip && (
          <div className="notification-tooltip">
            Thanks for exploring more on The Dubai Mock app. Unfortunately this feature hasn't been implemented yet.
          </div>
        )}
        <nav className="header-categories">
          <button
            className={`category-btn ${activeCategory === "SHOP" ? "active" : ""}`}
            onClick={() => handleCategoryClick("SHOP")}
          >
            SHOP
          </button>
          <button
            className={`category-btn ${activeCategory === "DINE" ? "active" : ""}`}
            onClick={() => handleCategoryClick("DINE")}
          >
            DINE
          </button>
          <button
            className={`category-btn ${activeCategory === "ENTERTAIN" ? "active" : ""}`}
            onClick={() => handleCategoryClick("ENTERTAIN")}
          >
            ENTERTAIN
          </button>
        </nav>
      </header>
    </>
  );
};

export default Header;
